import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  KmlLayer,
} from "react-google-maps";

const GoogleMapKmlLayer = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBSfRV-o63zy_ogfsrCfCibwTp4j3HB5pU&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: 35.81, lng: 51.24 }}
    options={{
      styles: props.styles,
    }}
  >
    {props.KmlLayers && (
      props.KmlLayers.map((kml)=>{
          return (
            <KmlLayer
              url={kml.url}
              defaultTitle="Vipera Test"
              options={{ preserveViewport: true }}
              label="test"
              icon="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
            />
          );
        })
    )}
  </GoogleMap>
));

export default GoogleMapKmlLayer;
